// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const LinkIcon = /* @__PURE__ */ createIcon(
  'link',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M10.425 8.01A6 6 0 0 1 14.8 10.4a1 1 0 1 1-1.602 1.198 4 4 0 0 0-5.876-.58l-.156.148-2.987 2.987-.133.145a4.001 4.001 0 0 0 2.974 6.635 4 4 0 0 0 2.815-1.123l1.697-1.698a1 1 0 1 1 1.414 1.414l-1.71 1.71-.228.211a6 6 0 0 1-8.467-8.467l.21-.228 3-3 .234-.222a6 6 0 0 1 4.439-1.521m6.571-6.944a6 6 0 0 1 4.264 10.168l-3.013 3.013A6.002 6.002 0 0 1 9.2 13.6a1 1 0 0 1 1.602-1.198 4 4 0 0 0 6.032.432l3-3a4.001 4.001 0 0 0-5.668-5.644l-1.71 1.7a1 1 0 1 1-1.41-1.418l1.72-1.71.01-.01a6 6 0 0 1 4.221-1.685',
      },
    ],
  ]
);
